import t from './assets/locales/messages_en.json';

type Keys = keyof typeof t;

export const keys = Object.keys(t).reduce(
  (acc, key) => ({ ...acc, [key]: key }),
  {} as Record<Keys, Keys>,
);
